type SearchTextQuery<T> = {
  ilike: (column: string, value: string) => T;
};

export function sanitizePostgrestSearchToken(token: string): string {
  return token.replace(/[,()]/g, "");
}

export function escapePostgrestIlikeValue(token: string): string {
  return sanitizePostgrestSearchToken(token).replace(/[%_]/g, "\\$&");
}

export function getSearchTextTokens(rawQuery: string | undefined | null): string[] {
  if (!rawQuery?.trim()) return [];

  return rawQuery
    .trim()
    .split(/\s+/)
    .map(sanitizePostgrestSearchToken)
    .filter((token) => token.length > 0);
}

export function applySearchTextTokenFilter<T extends SearchTextQuery<T>>(
  query: T,
  rawQuery: string | undefined | null
): T {
  for (const token of getSearchTextTokens(rawQuery)) {
    query = query.ilike("search_text", `%${escapePostgrestIlikeValue(token)}%`);
  }

  return query;
}
